import React, { useEffect, useRef, useState } from 'react'
import './secret-codes-list.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { Route, Routes, useNavigate } from 'react-router-dom';
import FoundCodeItem from '@/components/PLAYER/submit-code/found-code-item.component';
import PlayerNameIcon from '../player-name-icon.component';
import { getGameActivityFromDb } from '@/utils/getDataFromDb';
import TransactionView from '@/components/SHARED/transaction-view/transaction-view.component';

const MySecretCodesList = ({
  gameData,
  playerData,
  gameElements
}) => {

  const [loading, setLoading] = useState(true);
  const [sortedList, setSortedList] = useState([]);
  const [indActivityData, setIndActivityData] = useState(null);
  const navigate = useNavigate();
  const dataRef = useRef();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000)

    return () => {
      if (timer) clearTimeout(timer);
    }
  }, [])

  useEffect(() => {
    if (!playerData || !gameElements) return;
    getFoundCodesList();
  }, [playerData, gameElements])

  function getFoundCodesList() {
    getGameActivityFromDb({
      "gameId": playerData.gameId,
      "playerId": playerData.playerId,
      "activityType": 'secretCode',
      "once": true,
      "callback": callback,
    })
    function callback(data) {
      dataRef.current = {
        ...dataRef.current,
        ...data
      }
      setSortedList(Object.values(dataRef.current));
      setLoading(false);
    }
  }

  return (
    <div className='found-codes-list'>
      <Routes>
        <Route path='' element={
          <div className='g-card list-card'>
            <BackButton cancel={() => navigate(-1)} />
            {
              (playerData) &&
              <div>
                <div className='card-title split'>
                  Found Secret Codes
                  {
                    (location.pathname.includes('/manage/')) &&
                    <PlayerNameIcon player={playerData} />
                  }
                </div>
                <div className="g-space-1"></div>
                <hr className='no-margin' />
                <div className="g-space-0-5"></div>
                {
                  (sortedList) &&
                  <div className='summary meta'>
                    <div className='info'>
                      Found Secret Codes:
                      <ImageContainer src='/images/icons/secret.png' className='summary-icon' />
                      <b>{
                        playerData.secretCodes
                          ? Object.keys(playerData.secretCodes).length.toLocaleString()
                          : 0
                      }</b>
                    </div>
                  </div>
                }
              </div>
            }
            {
              (loading)
                ?
                <div className='center-col'><ThreeDotsLoader /></div>
                :
                (sortedList)
                  ?
                  sortedList
                    .sort((a, b) => b.ts - a.ts)
                    .map(a => {

                      return (
                        <div key={a.ts} >
                          <FoundCodeItem
                            codeInfo={a}
                            noSubmitForm={true}
                            setIndActivityData={setIndActivityData} />
                        </div>
                      )
                    })
                  :
                  <h4 className='center-col'>
                    No earnings yet...
                  </h4>
            }
          </div>
        }></Route>
        <Route path=':transPath/*' element={
          (gameData && indActivityData)
            ?
            <div className='g-card'>
              <TransactionView
                playerData={playerData}
                gameElements={gameElements}
                playerList={{ [playerData.playerId]: playerData }}
                hidePlayer={true}
                activityToDisplay={[indActivityData]}
              />
            </div>
            :
            <div></div>
        }></Route>
      </Routes>
    </div>
  )
}

export default MySecretCodesList